module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/install/install.component.less
// module id = ./src/app/view/install/install.component.less
// module chunks = main